<template>
  <div>
    <panel title="Widoki">
      <w-table
        entity-type="view"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @add="goToAddPage"
        @edit="goToEditPage($event.id)"
        @delete="showDeleteDialog($event.id)"
      />
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania widoków.',
  getError: 'Wystąpił błąd podczas pobierania danych widoku.',
  added: 'Dodano widok.',
  addError: 'Nie udało się dodać widoku.',
  updated: 'Zaktualizowano dane widoku.',
  updateError: 'Nie udało się zaktualizować danych widoku.',
  deleteConfirm: 'Czy na pewno chcesz usunąć widok?',
  deleted: 'Usunięto widok.',
  deleteError: 'Nie udało się usunąć widoku.'
};

// @vuese
// Lista widoków
// @group View
export default {
  components: { Panel, WTable },
  mixins: [listMixin('view', messages)],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'name', displayName: 'Nazwa', sortable: true }
    ],
    actions: DEFAULT_TABLE_ACTIONS
  }),
  methods: {
    // @vuese
    // Przechodzi do strony dodawania nowej encji
    goToAddPage() {
      this.$router.push({ name: 'viewAdd' });
    },
    // @vuese
    // Przechodzi do strony edycji encji
    goToEditPage(id) {
      this.$router.push({ name: 'viewEdit', params: { viewId: id } });
    }
  }
};
</script>
